import React, { ComponentProps, useState, useEffect } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';
import { fomatParentPath } from '../../utils';
import QuickCreateOpen from './quickCreateOpen';

function QuickCreateTest(props: RouteComponentProps & ComponentProps<any>) {
  let parentPath: string = fomatParentPath(props);
  
  return (
    <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/mobile/uk/testQuickCreate`}>
        <QuickCreateOpen weId={`${props.weId || ''}_s1m0pb`} />
    </Route>
  )
}

export default withRouter(QuickCreateTest);